import { render } from "./SatelitalImage.component.vue?vue&type=template&id=16948562&scoped=true&ts=true"
import script from "./SatelitalImage.component.vue?vue&type=script&lang=ts"
export * from "./SatelitalImage.component.vue?vue&type=script&lang=ts"

import "./SatelitalImage.component.vue?vue&type=style&index=0&id=16948562&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16948562"]])

export default __exports__